import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=7b2eedde"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports